export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00273.d3d6e53a.png";